import type {
    ApiResponse,
    IsAuthorizedResponse,
    LoginRequest,
    PasswordResetConfirmRequest,
    PasswordResetRequest,
    RegisterRequest,
} from "@/types/api";

import { request } from "./httpClient";

// Без авторизации (`auth: false`): без `Authorization`, без ожидания `authReady` и без refresh по 401.
// Сессию из ответа записывает `authSession`, а не вызывающий код.

export const login = (body: LoginRequest) => request<IsAuthorizedResponse>("POST", "/v1/login", { body, auth: false });

export const register = (body: RegisterRequest) =>
    request<IsAuthorizedResponse>("POST", "/v1/register", { body, auth: false });

/** Новый access-токен по refresh-cookie (`Path=/api/v1/isauthorized`) и ротация cookie. */
export const isAuthorized = () => request<IsAuthorizedResponse>("POST", "/v1/isauthorized", { auth: false });

export const requestPasswordReset = (body: PasswordResetRequest) =>
    request<ApiResponse<"requestPasswordReset">>("POST", "/v1/password-reset/request", { body, auth: false });

export const confirmPasswordReset = (body: PasswordResetConfirmRequest) =>
    request<IsAuthorizedResponse>("POST", "/v1/password-reset/confirm", { body, auth: false });

/** Требует `Authorization`; очищает refresh-cookie. */
export const logout = () => request<null>("POST", "/v1/logout");
